<div [class.padding]="padding()">
  @if (dataLoading()) {
    <app-loading-animation></app-loading-animation>
  }

  @if (dataAvailable()) {
    <app-table-template
      tableTitle="Invoice Details - {{customerName()}}"
      tableTitleId="invoice-details-title"
      [showTitle]="true"
      [showSearch]="true"
      [showPagination]="true"
      [hasCardView]="true"
      [clickableRows]="true"
      [columns]="columns()"
      [currentPage]="currentPage()"
      [sortedOn]="sortField()"
      [sortDescending]="sortOrder() === -1"
      [tableMinWidthInRem]="80"
      (sortChanged)="sort($event)"
      (searchChanged)="search($event)"
      (pageChanged)="page($event)"
      (rowClicked)="rowClicked($event)">
      <app-invoice-details-card [currentPage]="currentPage()" (buttonClicked)="rowClicked($event)"></app-invoice-details-card>
    </app-table-template>
  }

  @if (dataEmpty()) {
    <div class="empty">No invoice details available</div>
  }
</div>
